import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Supabase URL and Anon Key must be provided');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

// 인증 헬퍼 함수들
export const authHelpers = {
  // 현재 사용자 가져오기
  getCurrentUser: async () => {
    const { data: { user } } = await supabase.auth.getUser();
    return user;
  },

  // 프로필 가져오기
  getProfile: async (userId: string) => {
    const { data, error } = await supabase
      .from('profiles')
      .select('*')
      .eq('id', userId)
      .single();
    
    if (error) throw error;
    return data;
  },

  // 로그아웃
  signOut: async () => {
    const { error } = await supabase.auth.signOut();
    if (error) throw error;
  },

  // 이메일 로그인
  signInWithEmail: async (email: string, password: string) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      email,
      password,
    });
    if (error) throw error;
    return data;
  },

  signInWithPhone: async (phone: string, password: string) => {
    const { data, error } = await supabase.auth.signInWithPassword({
      phone,
      password,
    });
    if (error) throw error;
    return data;
  },

  // 이메일 회원가입 (이메일 인증 비활성화)
  signUpWithEmail: async (email: string, password: string, fullName: string) => {
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        data: {
          full_name: fullName,
        },
        emailRedirectTo: undefined, // 이메일 인증 비활성화
      },
    });
    if (error) throw error;
    return data;
  },

  signUpWithPhone: async (phone: string, password: string, fullName: string) => {
    const { data, error } = await supabase.auth.signUp({
      phone,
      password,
      options: {
        data: {
          full_name: fullName,
        },
      },
    });
    if (error) throw error;
    return data;
  },

  verifyOtp: async (phone: string, token: string) => {
    const { data, error } = await supabase.auth.verifyOtp({
      phone,
      token,
      type: 'sms',
    });
    if (error) throw error;
    return data;
  },

  // 소셜 로그인 (환경에 따라 동적 URL 사용)
  signInWithProvider: async (provider: 'google' | 'kakao') => {
    // 현재 환경의 origin 사용 (개발/프로덕션 자동 감지)
    const currentOrigin = window.location.origin;
    const redirectUrl = `${currentOrigin}/`;
    
    console.log('🔍 OAuth Redirect URL:', redirectUrl);
    console.log('🌍 Current Origin:', currentOrigin);
    
    const { data, error } = await supabase.auth.signInWithOAuth({
      provider: provider === 'kakao' ? 'kakao' : 'google',
      options: {
        redirectTo: redirectUrl,
      },
    });
    if (error) throw error;
    return data;
  },
};
